import React, { useState, useEffect } from 'react';
import { useHeaderFooterContext } from '../../../components';
import throttle from 'lodash.throttle';
import { Bar, Progress } from './ProgressBar.styles';
export function ProgressBar({ progressLabel }) {
    const [yPercent, setYPercent] = useState(0);
    const { footerHeight } = useHeaderFooterContext();
    useEffect(() => {
        // define handler
        const scrollPercentHandler = throttle(() => {
            const scrollTop = window.scrollY;
            const docHeight = document.body.offsetHeight;
            const windowHeight = window.innerHeight;
            const height = docHeight - windowHeight - footerHeight;
            const scrollPercent = Math.round(Math.min(100 / (height / scrollTop), 100));
            setYPercent(scrollPercent);
        }, 100);
        // set listener
        window.addEventListener('scroll', scrollPercentHandler);
        // remove listener
        return () => {
            window.removeEventListener('scroll', scrollPercentHandler);
        };
    }, [footerHeight]);
    return (React.createElement(Bar, null,
        React.createElement(Progress, { role: "progressbar", "aria-label": progressLabel, "aria-valuenow": yPercent, "aria-valuemin": 0, "aria-valuemax": 100, style: { width: `${yPercent}%` }, complete: yPercent === 100 })));
}
//# sourceMappingURL=ProgressBar.js.map